var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33301 14.6666V2.79189C1.33301 2.39845 1.47489 2.05699 1.75866 1.76751C2.04244 1.47805 2.38033 1.33331 2.77231 1.33331H13.2112C13.6037 1.33331 13.9444 1.47805 14.2332 1.76751C14.522 2.05699 14.6663 2.39845 14.6663 2.79189V10.7348C14.6663 11.1239 14.522 11.4616 14.2332 11.748C13.9444 12.0344 13.6037 12.1775 13.2112 12.1775H3.8162L1.33301 14.6666ZM2.77231 11.5117L3.54732 10.7348H13.2112V2.79189H2.77231V11.5117Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 4.66669H4.66667C4.29848 4.66669 4 4.96516 4 5.33335C4 5.70154 4.29848 6.00002 4.66667 6.00002H11.3333C11.7015 6.00002 12 5.70154 12 5.33335C12 4.96516 11.7015 4.66669 11.3333 4.66669Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66667 7.33331H4.66667C4.29848 7.33331 4 7.63179 4 7.99998C4 8.36817 4.29848 8.66665 4.66667 8.66665H8.66667C9.03486 8.66665 9.33333 8.36817 9.33333 7.99998C9.33333 7.63179 9.03486 7.33331 8.66667 7.33331Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoNote);
export default __webpack_public_path__ + "static/media/ico-note.7579e9cae133331f0cf4edef94dc353e.svg";
export { ForwardRef as ReactComponent };